export const GlobalDebug = (function () {
    var savedConsole = console;
    /**
    * @param {boolean} debugOn
    * @param {boolean} suppressAll
    */
    return function (debugOn, suppressAll) {
        var suppress = suppressAll || false;
        if (debugOn === false) {
            // eslint-disable-next-line no-native-reassign
            window.console = {};
            console.log = function () { };
            if (suppress) {
                console.info = function () { };
                console.warn = function () { };
                console.error = savedConsole.error;
            } else {
                console.info = savedConsole.info;
                console.warn = savedConsole.warn;
                console.error = savedConsole.error;
            }
        } else {
            // eslint-disable-next-line no-native-reassign
            window.console = savedConsole;
        }
    };
})();